import React from 'react';
import {PerforationDivider} from '../../../components/perforation-divider';

export const PublicProfileSkeleton: React.FC = () => {
  return (
    <div className="space-y-8 animate-pulse">
      <section className="rounded-2xl bg-white px-6 py-8 shadow-sm">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-center">
          <div className="h-20 w-20 rounded-full bg-[#E2E8F0]" />
          <div className="flex flex-1 flex-col gap-3">
            <div className="h-6 w-48 rounded-full bg-[#CBD5F5]" />
            <div className="h-4 w-72 rounded-full bg-[#E0E7FF]" />
            <div className="flex gap-3">
              <div className="h-3.5 w-24 rounded-full bg-[#C7D2FE]" />
              <div className="h-3.5 w-28 rounded-full bg-[#E2E8F0]" />
            </div>
          </div>
        </div>
      </section>

      <section className="grid gap-8 lg:grid-cols-[1.2fr_auto_1fr_auto_1.2fr]">
        <div className="space-y-4">
          <div className="h-5 w-28 rounded-full bg-[#CBD5F5]" />
          <div className="rounded-3xl bg-white p-4 shadow-[0_25px_70px_-40px_rgba(15,23,42,0.3)]">
            <div className="h-64 rounded-2xl bg-[#E2E8F0]" />
            <div className="mt-4 h-4 rounded-full bg-[#CBD5F5]" />
            <div className="mt-3 flex gap-2">
              <div className="h-6 w-20 rounded-full bg-[#DBEAFE]" />
              <div className="h-6 w-20 rounded-full bg-[#E0E7FF]" />
            </div>
            <div className="mt-4 flex gap-4 text-sm">
              <div className="h-4 w-14 rounded-full bg-[#CBD5F5]" />
              <div className="h-4 w-14 rounded-full bg-[#E2E8F0]" />
              <div className="h-4 w-14 rounded-full bg-[#C7D2FE]" />
            </div>
          </div>
        </div>
        <div className="hidden h-full lg:block">
          <PerforationDivider className="h-full" />
        </div>
        <div className="space-y-4">
          <div className="h-5 w-32 rounded-full bg-[#C7D2FE]" />
          <div className="space-y-4 rounded-3xl bg-white p-5 shadow-[0_25px_70px_-40px_rgba(15,23,42,0.3)]">
            <div className="h-64 rounded-2xl bg-[#DBEAFE]" />
            <div className="flex gap-2">
              <div className="h-6 flex-1 rounded-full bg-[#E0E7FF]" />
              <div className="h-6 flex-1 rounded-full bg-[#CBD5F5]" />
              <div className="h-6 flex-1 rounded-full bg-[#E2E8F0]" />
            </div>
            <div className="space-y-3 rounded-2xl bg-[#F1F5F9] p-4">
              <div className="h-4 w-40 rounded-full bg-[#CBD5F5]" />
              <div className="h-4 w-48 rounded-full bg-[#E0E7FF]" />
            </div>
          </div>
        </div>
        <div className="hidden h-full lg:block">
          <PerforationDivider className="h-full" dense />
        </div>
        <div className="space-y-4">
          <div className="h-5 w-28 rounded-full bg-[#93C5FD]" />
          <div className="rounded-3xl bg-white p-5 shadow-[0_25px_70px_-40px_rgba(15,23,42,0.3)]">
            <div className="h-40 rounded-2xl bg-[#3B82F6]/20" />
            <div className="mt-4 h-4 w-48 rounded-full bg-[#DBEAFE]" />
            <div className="mt-2 h-4 w-40 rounded-full bg-[#E0E7FF]" />
          </div>
          <div className="rounded-3xl bg-white p-5 shadow-[0_25px_70px_-40px_rgba(15,23,42,0.3)]">
            <div className="h-32 rounded-2xl bg-[#E2E8F0]" />
            <div className="mt-4 h-4 w-48 rounded-full bg-[#CBD5F5]" />
            <div className="mt-2 h-4 w-36 rounded-full bg-[#E0E7FF]" />
          </div>
        </div>
      </section>
    </div>
  );
};
